var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy policy-view",domProps:{"innerHTML":_vm._s(_vm.policy)}})
}
var staticRenderFns = []

export { render, staticRenderFns }